export default __webpack_public_path__ + "static/media/limit_75.09d3ab87.svg";